import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
    selector: '[refreshButton]',
    templateUrl: 'refresh-button.component.html',
    styleUrls: ['refresh-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RefreshButtonComponent {}
